<template>
  <div>
    <div class="page-header">
      <div class="container-fluid">
        <h2 class="h5 no-margin-bottom">Yeni Servis Planı</h2>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
          <div class="block" >
            <div class="block-body">
             <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-12">
                  <div class="row">
                    <div class="col-12">
                      <label class="form-control-label dashtext-3 (**)">Müşteri **</label>
                      <v-autocomplete :items="items" v-model='item' :get-label='getLabel' :min-len='0' @update-items='update' :component-item='tpl' @item-selected="itemSelected" @item-clicked="itemClicked" :input-attrs="{name: 'input-test', id: 'v-my-autocomplete'}">
                      </v-autocomplete>
                    </div>
                  </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="table-responsive"> 
                          <table id="tablo" class="table table-striped">
                              <tbody class="bg-dark">
                              <tr v-for="post in cihaz" :key="post.id">
                                <td>{{post.barkod}}</td>
                                <td>{{post.model}}</td>
                                <td>{{$helper.trtgoster(post.tarih)}}</td>
                                <td class="dashtext-3">{{post.sn}}</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                      </div>
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                      <div class="row mb-3">
 <!-- @change="sttip($event)" -->
                        <div class="col-lg-6 col-12">
                        <label class="form-control-label dashtext-3">Servis Tipi *</label>
                          <select v-model="newpost.st" class="form-control">
                            <option value="0">Servis Tipi Seç</option>
                            <option v-for="(option,index) in st" :value="option.id" :key="index">{{ option.alias }}
                            </option>
                          </select>
                        </div>

                        <div class="col-lg-6 col-12">
                          <label class="form-control-label">Sağlayıcı</label>
                            <select disabled  v-model="newpost.sa" class="form-control">
                              <option value="0">Sağlayıcı Yok</option>
                              <option v-for="(option,index) in salar" :value="option.id" :key="index">{{ option.alias }}</option>
                            </select>
                        </div>

                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-6 col-12">
                          <label class="form-control-label dashtext-3">Servis Nedeni ***</label>
                            <select v-model="newpost.sn" class="form-control">
                              <option value="0">Servis Nedeni Seç</option>
                              <option v-for="(option,index) in reversedMessage" :value="option.id" :key="index">{{ option.alias }}
                                </option>
                            </select>
                        </div>
                        <div class="col-lg-6 col-12">
                            <label class="form-control-label dashtext-3">Servis Öncelik</label>
                            <select v-model="newpost.so" class="form-control">
                            <option value="0">Servis Öncelik Seç</option>
                            <option value="1">Düşük</option>
                            <option value="2">Orta</option>
                            <option value="3">Yüksek</option>
                            </select>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-6 col-12">
                            <label class="form-control-label">Çağrı Tarihi</label>
                            <input readonly type="text" class="form-control" v-model="newpost.ct">
                        </div>
                        <div class="col-lg-6 col-12">
                            <label class="form-control-label">Çağrı Saati</label>
                            <input readonly type="time" class="form-control" v-model="newpost.cs">
                        </div>
                      </div>
                      
                      <div class="row mt-4 mb-3">
                        <div class="col-12">
                           <textarea style="height:100px" v-model="newpost.not" placeholder="Servis Notu" class="form-control" rows="10"></textarea>
                        </div>
                      </div>
                      <div class="row mt-3 mb-3">
                        <div class="col-lg-6 col-12">
                          <button @click="newpost.sd = 1; newpost.bolge = 0" class="btn btn-outline-danger w-100 btn-lg">Beklemede Kalsın</button>
                        </div>
                         <div class="col-lg-6 col-12">
                           <button @click="newpost.sd = 2" class="btn btn-outline-info btn-lg w-100">Hemen Yönlendir</button>
                         </div>
                      </div>
                      <div v-if="newpost.sd === 2" class="row mt-3 mb-3">

                        <div class="col-12">
                          <label class="form-control-label">Yönlendirilecek Bölge</label>
                            <select v-model="newpost.bolge" class="form-control">
                            <option v-for="(option,index) in bolge" :value="option.id" :key="index">{{ option.alias }}</option>
                            </select>
                        </div>
 
                      </div>
                      <div class="row mt-2">
                        <div class="col-12">
                           <button :disabled="progres.inprogres" @click="sendNewPost()" class="btn btn-danger d-block w-100 btn-lg">Servis Ekle</button>
                        </div>
                      </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
<!--{{item}}-->
<div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
</div>
</template>
<script>
import Autocomplete from './Autocomplete.vue'
import tpl from './TplItem.vue'
//import Animals from './animals.js'
export default {
  name: 'demo',
  components: {'v-autocomplete': Autocomplete},
  data () {
    return {
      itemsApi: [],
      item: {},
      items: [],
      posts:[],
      tpl: tpl,
      searchText:'',
      error:[],
      cihaz:[],
      donem : this.$request.donem(),
      kid:this.$request.ayar().kid,
      ya:this.$request.ayar().ya,
      sn:[],
      st:[],
      so:[],
      salar:[],
      bolge:[],
      akod:'', // sn süzmek için cihazgrup kodunu aldık
      txt:'',
      newpost: {
        firma: this.$request.ayar().firmaid,
        id: '',
        sn: 0,
        st: 0,
        so: 0,
        sa: 0,
        sd:1,
        ct:this.$helper.getNow().tarih,
        cs:this.$helper.getNow().saat,
        not:'',
       // ckod:'',
        //cad:'',
        carid:0,
        servisno:'',
        bolge:0
      },
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      }
  }    
  },
    created() {
//      await this.cdgetir('cd')
     // this.progres.inprogres = true
      //this.sagetir();
      this.yetki(this.sagetir,this.stf,this.sof)
      //setInterval(this.getNow,1000);
      //this.getPostsAsync()
      this.sttip()
    },
  computed: {

    reversedMessage () {
      if(this.newpost.st!=0){
      if (this.newpost.st === 2){
        //this.newpost.sn = 0
       this.$request.get("sngetir/"+this.akod)
        .then(res=> {this.sn = res.results
          
        })
      }
      else{

        this.$request.get("sngetir2/"+this.newpost.st)
        .then(res => {this.sn = res.results
          if (this.newpost.st!=2){this.newpost.sn = res.results[0].id }
          else{
            //this.newpost.sn=0
            }
        })
        .catch(err => this.error.push(err))
        
      }
      }
      return this.sn
    }
  }, 
  methods: {
    yetki : function(sa,st,so){ 
          if (this.$helper.sayfayetki(610696)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                this.txt="where k.kid_ ="+this.kid //sagetir için
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
                this.txt="where s.firma ="+this.newpost.firma //sagetir için
            }
                if(islem){this.sagetir()}
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
          sa();
          st();
          so();
    },
    sagetir(){
          this.$request.get("sagetir/"+this.txt)
          .then(res => {
            if (res.status === 200){this.salar = res.results}
            else{this.sa.push({"id" : 0,"alias" : "Sağlayıcı yok"})}
          })
          .catch(err => this.error.push(err))
    },

    sendNewPost(){
      if (this.newpost.st!=0 && this.newpost.sd!=0 && this.newpost.so!=0 && this.newpost.sn!=0 && this.newpost.carid) {
            this.$swal({
              title: 'Onaylıyor musunuz?',
              text: 'Servisi Eklenecek...',
              type: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    this.progres.inprogres = true;
                    this.progres.mesaj = 'Bekleyiniz...';
                    this.$request.get("serviscount/"+this.newpost.firma+"/"+this.donem)
                      .then(res => {
                        if (res.status === 200) 
                        {
                          this.newpost.servisno = res.results[0].adet
                          this.sendNewPost2()
                        }
                      })
                      .catch(err)
                  }
                })
     }
     else{
       this.$swal("Girdileri Kontrol Et")
     } 
     },
    sendNewPost2(){
      this.$request.post("servis/",this.newpost)
      .then(res => {
        let log = {
          servis_id : res.data.id,
          tarih:res.data.tarih,
          saat : res.data.saat,
          sd:res.data.sd,
          kid:this.kid,
          islem: 'Servis Eklendi'
        }
          this.$request.post("servis_log/",log)
            .then(res => {
                //this.progres.inprogres = true;
                this.progres.mesaj = 'Log Kaydı Yapıldı...';
               this.$swal('İşlem Başarılı', 'Servis Başarı ile açıldı', 'success')
            })
            this.progres.inprogres = false;
            this.progres.mesaj = 'Servis Eklendi...';
      })
      .catch(err => {this.error.push(err)
            this.progres.inprogres = false;
            this.progres.mesaj = 'Tekrar Deneyin...';
      })
    },

    itemSelected (item) { // cihaz id ye göre cihaz geçmişi
      this.$request.get("detay/cihaz/"+item.id+'/'+this.donem)
      .then(data => {this.cihaz = data.results.sort((t1,t2) => t1.id > t2.id ? -1 : 1)})
      .catch(err => {this.error.push(err)})
      this.newpost.id = item.id //cihazid
     // this.newpost.ckod = item.carikod
      //this.newpost.cad = item.cariad
      this.newpost.carid = item.carid
      this.newpost.sa = item.said
      this.akod = item.akod
    },
    itemClicked (item) {
     // alert('You clicked an item!', item)
      this.newpost.carid = item.carid
      //this.newpost.ckod = item.carikod
     // this.newpost.cad = item.cariad
      this.newpost.id = item.id
      this.newpost.sa = item.said
      this.akod = item.akod
      //this.progres.inprogres = true
    },
    getLabel (item) {
      if (item) {
        return item.cariad
      }
      return ''
    },
    update (text) {
      //this.items = Animals.filter((item) => {
      this.items = this.posts.filter((item) => {
        return (new RegExp(text.toLowerCase())).test(item.cariad.toLowerCase())
      })
    },

    sttip(event){
      //console.log(this.ya+'-'+this.kid+'-'+this.newpost.firma)
      this.progres.inprogres = true
      this.posts = [];
      this.newpost.sn = 0;
      this.$request.get("yeniservis/"+this.ya+"/"+this.kid+"/"+this.newpost.firma)
      .then(data => {
        this.posts = data.results;
        this.progres.inprogres = false
      })
      .catch(err => {this.errors.push(err)})
    },

    stf(){
      this.$request.get("stgetir")
      .then(res => {this.st = res.results
      this.sof('so')
      })
      .catch(err => this.error.push(err))
    },

    sof(tip){
      this.$request.get("define/"+this.newpost.firma+"/so")
      .then(res => {this.so = res.results
      this.bolgegetir()
      })
      .catch(err => this.error.psuh(err))
       
    },
    bolgegetir(){
      this.$request.get("bolge/"+this.newpost.firma)
      .then(res => {this.bolge = res.results
      this.progres.inprogres = false
      setTimeout(()=> {this.progres.inprogres = false}, (1000) ) 
      })
    },
  },
  // watch: {
  //   akod(val){
  //     this.fullName = val + ' ' + this.lastName
  //   },
  // },
}
</script>
<style scoped>
.form-control{height: calc(2.4rem + 15px);font-size: 16px; border-radius:0%;}
</style>


// WEBPACK FOOTER //
// src/views/servis/create.vue